import { AxiosError } from 'axios';
import { QUERY_KEYS } from 'src/enums';
import { cancelCourseContent } from 'src/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useCancelCourseContent = () => {
  const client = useQueryClient();

  const { mutate, isLoading } = useMutation<{ success?: boolean }, AxiosError, { id: number }>(
    ['cancel-course-content'],
    ({ id }) => cancelCourseContent(id),
    {
      onSuccess: () => {
        client.invalidateQueries([QUERY_KEYS.CAREER_CONTENT]);
      }
    }
  );

  return {
    mutate,
    isLoading
  };
};

export default useCancelCourseContent;
